import { z } from 'zod'
import { RewardCategory } from '@library/enums/reward-category'

export const managerBenefitClassTypeSchema = z.object({
  /** 分類選項 */
  classType: z.enum(RewardCategory),
  /** 分類次選項 */
  classSecondType: z.string(),
  /** 分類第三選項 */
  classThirdType: z.string(),
  /** 套裝商品禮遇項目 */
  suitClassType: z.array(z.string()).optional()
})

export interface ManagerBenefitClassType
  extends z.infer<typeof managerBenefitClassTypeSchema> {}
